/**
 * User Store
 *
 * Global user context and authentication state
 */

import { create } from 'zustand';

export interface User {
  id: string;
  name: string;
  email?: string;
  avatar?: string;
  permissions: string[];
  attributes?: Record<string, unknown>;
}

export interface UserStore {
  user: User | null;
  isLoading: boolean;
  error: string | null;
  setUser: (user: User) => void;
  clearUser: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  updateUser: (updates: Partial<User>) => void;
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  isLoading: false,
  error: null,

  setUser: (user: User) => set({ user, error: null }),

  clearUser: () => set({ user: null }),

  setLoading: (isLoading: boolean) => set({ isLoading }),

  setError: (error: string | null) => set({ error }),

  updateUser: (updates: Partial<User>) =>
    set((state) => ({
      user: state.user ? { ...state.user, ...updates } : null,
    })),
}));
